export const BookingCalendarDateFormats = {
  DateShortMonth: 'd MMM',
  Day: 'EEE',
  Date: 'd',
  ShortMonth: 'MMM',
  DayDateMonthYear: 'EEE d MMM y',
} as const;
